import React, { useState, useContext } from 'react';
import OtpInput from 'react-otp-input';
import { IoCloseSharp } from 'react-icons/io5';
import ReactSpinnerTimer from "react-spinner-timer";
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../interfaces/api';
import BillsInfoContext from '../../context/BillsInfoContext/BillsInfoContext';
import { USER } from '../../interfaces/auth.interface';
import { BeatLoader, Spinner } from '../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const PaymentValidationTimer: React.FC<Props> = ({ 
    modal,
    hideModal,
    showModal,
    user,
    resetApi,
    validatepayment,
    validatePaymentState
 }) => {

    const refCode = modal?.ownProps?.refCode; 
    const closeModal = () => {
        hideModal();
      };

    
  React.useEffect(
    () => () => {
      resetApi(API_KEYS.CHARGE_WALLET);
      resetApi(API_KEYS.SEND_PAY_ADVICE);
      resetApi(API_KEYS.VALIDATE_BILLS_PAYMENT);
      resetApi(API_KEYS.VERIFY_USER_PIN);
    },
    [resetApi]
  );

  const [lapValue, setLapValue] = useState<any>();

  const handleOnLapInteraction = (lap: any) => {
    if (lap.isFinish) 
    // console.log("Finished!");
    setLapValue(lap);
  };

   React.useEffect(() => {
     if(lapValue?.isFinish === true){
        validatepayment({
            Reference: refCode
         })
     }
   },[validatepayment, lapValue?.isFinish]);


    React.useEffect(() => { 
        if(!validatePaymentState?.loading && validatePaymentState?.success ){
          closeModal();
      }
    },[!validatePaymentState?.loading, validatePaymentState?.success, closeModal])

    // React.useEffect(() => {
    //     // closeModal();
    //     if(validatePaymentState?.success && validatePaymentState?.response?.Object === 'Transaction was successful'){
    //        showModal({
    //         component: 'BillSuccessful',
    //         modalProps: {
    //           contentLabel: 'Bill Successful Modal',
    //         }
    //       });
    //     }
        // else if(validatePaymentState?.success && validatePaymentState?.response?.Object !== 'Transaction was successful'){
        //   showModal({
        //     component: 'BillFailed',
        //     modalProps: {
        //       contentLabel: 'Bill Failed Modal',
        //     },
        //     ownProps: {
        //       errorMsg: validatePaymentState?.response?.Object
        //     }
        //   });
        // }
      // },[validatePaymentState?.success,validatePaymentState?.response?.Object, showModal])
    
      if (validatePaymentState?.loading ) {
        return (
          <div className="w-full flex items-center justify-center pt-4 overflow-hidden">
          <Spinner color="#CCC" />
        </div>
        );
        
      }
       
    // <ModalWrapper hideCloseButton hideModal={hideModal}>
    return(
      <div className="w-full px-8 bg-white lg:px-24 py-10 relative">
          <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
       <div className="w-full my-2 flex justify-center">
            <ReactSpinnerTimer
            timeInSeconds={15}
            totalLaps={1}
            isRefresh={false}
            // onLapInteraction={handleChange}
            onLapInteraction={(lap: any) => handleOnLapInteraction(lap)}
            />
        </div>
        <div className="w-full max-w-md mx-auto text-center mb-10 text-sm">
          <p className="text-gray-500 my-4">
              Validating transaction Please wait...
         </p>
     </div>
    </div>
    );
  };
  
  export default PaymentValidationTimer;
  
